const stripHTMLTagsFromString = (string) => {
  console.log("string", string);
  // PARSE STRING INTO NEW HTML DOCUMENT
  let parsed = new DOMParser().parseFromString(string, "text/html");
  console.log("parsed", parsed.body.textContent);
  // STRIP TAGS, RETURN AS TEXT CONTENT
  return parsed.body.textContent;
};

export default stripHTMLTagsFromString;
